import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import AboutView from './components/About';
import { Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SearchView from './components/SearchView';
import MovieView from './components/SellerView';
import Footer from './components/Footer';

function App() {
  const [searchResults, setSearchResults] = useState([])
  const [searchText, setSearchText] = useState('')
  
  useEffect(() => {
    fetch('https://kakilima.antha.my.id/api/places')
      .then(response => response.json())
      .then(data => {
        setSearchResults(data.data)
        console.log(data.data)
      })
      .catch(err => console.error(err))
  }, []) // <- dependency array kosong, artinya fetch hanya sekali waktu mount

  useEffect(() => {
    // Misalnya: mengatur title halaman setiap kali searchResults berubah
    fetch(`https://kakilima.antha.my.id/api/places?search=${encodeURIComponent(searchText)}`)
      .then(response => response.json())
      .then(data => {
        setSearchResults(data.data)
        console.log(data.data)
      })
      .catch(err => console.error(err))
    console.log(searchText)
  }, [searchText]) // Dijalankan setiap searchResults berubah

  return (
    <div>
      <Navbar searchText={searchText} setSearchText={setSearchText}/>
      <Routes>
        <Route path="/" element={<Home keyword={searchText} searchResults={searchResults}  />} />
        <Route path="/about" element={<AboutView />} />
        {/* <Route path="/search" element={<SearchView keyword={searchText} searchResults={searchResults} />} />
        <Route path="/seller/:id" Component={MovieView} /> */}
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
